import $ from 'jquery';

class Cart {


  _handleItem(actionUrl, parameters) {
    location.href=actionUrl+"?"+$.param(parameters);
  }




}

export default Cart;